import { Component, OnInit } from "@angular/core";
import { OidcSecurityService } from "angular-auth-oidc-client";

@Component({
  selector: "app-forbidden",
  templateUrl: "./forbidden.component.html",
})
export class ForbiddenComponent implements OnInit {

  date : Date = new Date();

  constructor(private oidcSecurityService: OidcSecurityService) {}

  ngOnInit(): void {
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);
      
    });
  }
}
